import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import { IExplorerLoginResponse, INetworkResponse } from './network.type'

export class Network extends ServiceBase {
  private mainURL = '/network'

  public async getNetworkByCompanyId(): Promise<INetworkResponse> {
    const url = `${this.mainURL}`

    const response = await this.request.get<INetworkResponse, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getExploreUserByCompanyId(
    userId: string | undefined,
  ): Promise<IExplorerLoginResponse> {
    const url = `${this.mainURL}/explorer-connect/${userId}`

    const response = await this.request.get<IExplorerLoginResponse, IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
